import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from "moment";
export default {
  props: {
    uplodData: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  name: "uplodModal",
  data: function data() {
    return {
      btnState: true,
      FormData: {
        dimYear: moment(new Date()).format("YYYY")
      },
      proName: "",
      maxUploadFileSize: 10 * 1024 * 1024,
      hasExistFile: false,
      standardFileState: {
        state: true,
        formatFileType: ["xls", "xlsx"]
      },
      arrFile: [],
      uploadData: {// dimYear:null,
        // file:null,
      }
    };
  },
  created: function created() {
    var token = window.sessionStorage.getItem("nz_access_token");
    this.imHeader = {
      Authorization: token
    };
  },
  methods: {
    handleBeforeUpload: function handleBeforeUpload(file) {
      // this.uploadData.dimYear = new Date(this.FormData.dimYear).getFullYear();
      this.hasExistFile = true;

      if (file.size > this.maxUploadFileSize) {
        this.$message.error("上传文件最大不能超过10M，请检查文件上传大小！");
        return false;
      }

      var extname = file.name.substr(file.name.lastIndexOf(".") + 1, file.name.length - file.name.lastIndexOf("."));
      var foundext = false;
      this.standardFileState.formatFileType.forEach(function (e) {
        if (e == extname) {
          foundext = true;
        }
      });

      if (!foundext) {
        this.$message.error("上传的文件类型非指定的文件类型，请选择指定的文件类型");
        return false;
      } // this.uploadData.file = file;
      // console.log(this.uploadData)

    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          message: "上传成功",
          type: "success"
        });
        this.$emit("successCallBack");
        this.closeBtn();
      } else {
        this.proName = "文件上传失败：失败原因：" + response.msg;
      }

      this.btnState = false;
    },
    closeBtn: function closeBtn() {
      this.proName = "";
      this.hasExistFile = false;
      this.FormData.dimYear = moment(new Date()).format("YYYY");
      this.btnState = true;
      this.arrFile = [];
      this.$emit("closeUplod", false);
    }
  }
};